<section hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle>Shop auf deiner Website einbinden</h2>
    <p hlmCardDescription>
      Wähle, wie dein Gutschein-Shop erscheinen soll, und kopiere den Code in deine Website.
    </p>
  </div>

  <div hlmCardContent class="space-y-5">
    <!-- Variant: native radios, so arrow keys and screen readers work out of the box -->
    <fieldset class="grid gap-3 sm:grid-cols-2">
      <legend class="sr-only">Darstellung auf deiner Website</legend>
      @for (option of variants; track option.value) {
        <label
          class="hover:bg-muted/50 has-[:checked]:border-primary has-[:checked]:ring-primary has-[:focus-visible]:ring-ring/50 flex cursor-pointer items-center gap-3 rounded-lg border p-3 transition-colors has-[:checked]:ring-1 has-[:focus-visible]:ring-[3px]">
          <input
            type="radio"
            name="embed-variant"
            class="sr-only"
            [value]="option.value"
            [checked]="variant() === option.value"
            (change)="variant.set(option.value)" />

          <!-- Mini sketch of the variant -->
          <span
            class="bg-background relative h-10 w-12 shrink-0 overflow-hidden rounded border"
            aria-hidden="true">
            @if (option.value === 'widget') {
              <span class="bg-primary absolute end-1 bottom-1 h-1.5 w-5 rounded-sm"></span>
            } @else {
              <span class="bg-muted-foreground/20 absolute inset-x-1 top-1 h-1 rounded-full"></span>
              <span
                class="border-primary bg-primary/10 absolute inset-x-1 top-3 bottom-1 rounded-sm border"></span>
            }
          </span>

          <span class="min-w-0 space-y-0.5">
            <span class="block text-sm font-medium">{{ option.label }}</span>
            <span class="text-muted-foreground block text-xs">{{ option.description }}</span>
          </span>
        </label>
      }
    </fieldset>

    <div class="grid gap-4 md:grid-cols-[minmax(0,1fr)_13rem]">
      <app-code-block title="Code für deine Website" [lines]="lines()">
        <p class="text-muted-foreground border-t px-3 py-2.5 text-xs">{{ selected().placement }}</p>
      </app-code-block>

      <app-embed-preview
        [variant]="variant()"
        [primaryColor]="primaryColor()"
        [textColor]="textColor()"
        [title]="shopTitle()"
        [freeAmount]="freeAmount()"
        [fixedAmounts]="fixedAmounts()"
        [products]="products()" />
    </div>

    @if (website()) {
      <div hlmAlert>
        <ng-icon name="lucideInfo" />
        <p hlmAlertTitle>Freigegeben für {{ website() }}</p>
        <p hlmAlertDescription>
          Der Code funktioniert nur auf dieser Domain.
          <a
            [routerLink]="[]"
            [queryParams]="{ tab: 'company' }"
            class="underline underline-offset-4">
            Website ändern
          </a>
        </p>
      </div>
    } @else {
      <div hlmAlert variant="warning">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertTitle>Keine Website hinterlegt</p>
        <p hlmAlertDescription>
          Der Code funktioniert nur auf deiner freigegebenen Domain.
          <a
            [routerLink]="[]"
            [queryParams]="{ tab: 'company' }"
            class="underline underline-offset-4">
            Website jetzt hinterlegen
          </a>
        </p>
      </div>
    }
  </div>
</section>
